import { ChevronRightRounded } from '@mui/icons-material'
import { Card, CardContent, CardHeader, Grid, IconButton, SxProps, Theme } from '@mui/material'

import { FC } from 'react'
import { getReadableTakeOverReason } from '../../../../domain/Animal/AnimalDisplay'
import { AnimalDto } from '../../../../interactors/gen/backendClient'

import { ReadOnlyItem } from '../../../common/ReadOnlyItem'
import { EditAnimalTakeOverPrompt } from './EditAnimalTakeOverPrompt'
import dayjs from 'dayjs'

interface Props {
  animal: AnimalDto
  sx?: SxProps<Theme>
}

export const AnimalTakeOverCard: FC<Props> = ({ animal, sx }) => {
  const defaultItemProps = { xs: 6, sm: 6, item: true, marginBottom: 2 }
  const takeOverDateDisplay = animal.takeOver.takeOverAt ? dayjs(animal.takeOver.takeOverAt).format('DD/MM/YYYY') : '..'
  const cityDisplay = animal.takeOver.cityOfOrigin || '..'

  return (
    <>
      <Card sx={sx}>
        <CardHeader
          title="🤗 Prise en charge"
          titleTypographyProps={{ sx: { fontSize: { xs: 15.5, sm: 16 }, fontWeight: 700, lineHeight: 1.2 } }}
          action={
            <EditAnimalTakeOverPrompt
              animal={animal}
              customTrigger={(onClick) => (
                <IconButton
                  onClick={onClick}
                  sx={{
                    width: 32,
                    height: 32,
                    borderRadius: 2,
                    color: '#203864',
                    backgroundColor: 'rgba(32, 56, 100, 0.08)',
                    '&:hover': { backgroundColor: 'rgba(32, 56, 100, 0.14)' },
                  }}
                >
                  <ChevronRightRounded sx={{ fontSize: 20 }} />
                </IconButton>
              )}
            />
          }
          sx={{
            '& .MuiCardHeader-action': {
              alignSelf: 'flex-start',
              mt: 0.25,
              mr: 0.25,
            },
          }}
        />
        <CardContent sx={{ pt: 0 }}>
          <Grid container spacing={1}>
            <Grid {...defaultItemProps}>
              <ReadOnlyItem label="Date & Lieu" value={`${takeOverDateDisplay} - ${cityDisplay}`} />
            </Grid>

            <Grid {...defaultItemProps}>
              <ReadOnlyItem
                label="Motif"
                value={animal.takeOver.reason ? getReadableTakeOverReason(animal.takeOver.reason) : '..'}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}
